import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const RoomCard = ({ title, price, image, code }) => {
  const { t } = useTranslation();
  return (
    <div className=" overflow-hidden">
      <div className="w-full h-[300px] overflow-hidden">
        <img
          src={image[0]}
          alt={title}
          className="w-full h-full object-cover  hover:scale-110 duration-[0.5s]"
        />
      </div>
      <div className="p-4">
        <h3 className="text-lg font-[500] font-cormorant">{title}</h3>
        <p className="text-gray-600 font-cormorant">{price}</p>
        <div className="mt-[9px]">
          <Link
            to={{
              pathname: "/rooms/detail-rooms",
              search: `?${code}`,
            }}
            className=" bg-[#D4AF37] text-black px-4 py-2 rounded text-[14px]"
          >
            {t("VIEW_DETAILS")}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default RoomCard;
